import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalProperties } from 'src/app/global/global-properties';

declare var oidc: any;

@Injectable({
  providedIn: 'root'
})
export class OidcClientManagerService {
  private openIdConnectProviderUrl: string;
  private userInfoUrl: string;
  private clientSettings: any; 
  private userManager: any;
  private DEFAULT_SETTINGS = {
    authority: '',
    //redirect_uri: GlobalProperties.redirectUri,
   // post_logout_redirect_uri: GlobalProperties.postLogoutRedirectUri,


//  redirect_uri: "https://localhost:3300/",
//  post_logout_redirect_uri: 'https://localhost:3300/',
  redirect_uri: "https://erp.ubshanacloud.in/",
   post_logout_redirect_uri: 'https://erp.ubshanacloud.in/',


  // redirect_uri: "https://uneecops-erp-production.rocket.cosmocloud.io/",
  // post_logout_redirect_uri: 'https://uneecops-erp-production.rocket.cosmocloud.io/',

    response_type: 'code',
    response_mode: 'fragment',
    scope: 'openid',
    automaticSilentRenew: false,
    monitorSession: false,
    filterProtocolClaims: true,
    loadUserInfo: true
  };

  constructor(private http: HttpClient) {
    this.openIdConnectProviderUrl = "/sld/sld0100.svc/GetOpenIDConnectProvider";
    this.userInfoUrl = "/sld/sld0100.svc/CurrentUserInfo";
    this.clientSettings = { ...this.DEFAULT_SETTINGS };
  }

  getClientSetting() {
    return this.clientSettings;
  }
  async init(clientSettings: any, openIdConnectProviderEndpoint = '', userInfoEndpoint = ''): Promise<any> {
    this.openIdConnectProviderUrl = openIdConnectProviderEndpoint || this.openIdConnectProviderUrl;
    this.userInfoUrl = userInfoEndpoint || this.userInfoUrl;
    this.clientSettings = { ...this.DEFAULT_SETTINGS, ...clientSettings };

    try {
      const authority = await this.getAuthorityEndpoint();
      this.clientSettings.authority = authority;
      this.clientSettings.metadataUrl = authority;
      // @ts-ignore
      this.userManager = new oidc.UserManager(this.clientSettings);
      try {
        // @ts-ignore
        const user = await this.userManager.signinRedirectCallback();
        window.history.replaceState(null, window.document.title, ' ');
        return user;
      } catch (err: any) {
        if (err.message === "No state in response" || err.message === "No matching state found in storage") {
          console.log('err',err)
          await this.startSigninMainWindow();
          return;
        } else {
          throw this.formatOidcErr(err);
        }
      }
    } catch (err) { 
      throw err;
    }
  }

  // async startSigninMainWindow(): Promise<void> {
  //   if (!this.userManager) return;
  //   // @ts-ignore
  //   await this.userManager.signinRedirect({});
  // }


  async startSigninMainWindow(): Promise<void> {
    if (!this.userManager) return;
    // @ts-ignore
    await this.userManager.signinRedirect({ prompt: 'login' });
  }

  // async startSignoutRedirect(): Promise<void> {
   
  //   if (!this.userManager) return;
  //   // @ts-ignore
  //   await this.userManager.signoutRedirect({});
  // }

  async startSignoutRedirect(): Promise<void> {
 
    if (!this.userManager) return;
 
    const idToken = sessionStorage.getItem('sapToken')?.replace(/^"|"$/g, '');
 
    const logoutUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/logout` +
      `?post_logout_redirect_uri=${encodeURIComponent('https://localhost:3300')}` +
      `&id_token_hint=${idToken}` +
      `&logout_hint=${encodeURIComponent('indrajeet.chaurasia@uneecops.com')}`
      ;
 
    this.userManager.removeUser();
 
    sessionStorage.clear(); // or sessionStorage.removeItem('sapToken');
 
    console.log("saptoken" + idToken);
    window.open('https://login.microsoftonline.com/common/oauth2/logout', '_blank');
 
    // window.location.href = logoutUrl; //with logout url
 
    // await this.userManager.signoutRedirect({}); // as per SAP
  }

  async getUser(): Promise<any> {
    if (!this.userManager) return null;
    // @ts-ignore
    return this.userManager.getUser();
  }

  async getAuthorityEndpoint(): Promise<string> {
    try {
      const data: any = await this.http.get(this.openIdConnectProviderUrl).toPromise();
      const authEndpoint = data?.d?.GetOpenIDConnectProvider?.DiscoveryUri;
      if (authEndpoint) {
        return authEndpoint;
      } else {
        throw new Error('The DiscoveryUri does not set!');
      }
    } catch (err: any) {
      if (err.name === "TimeoutError") {
        throw new Error("Sorry, request time out!");
      }
      throw err;
    }
  }

  validateToken(token: string, beforeExpireSeconds = 0): boolean {
    if (!token) return false;
    const jwtSplit = token.split('.');
    if (jwtSplit.length !== 3) return false;
    const body = JSON.parse(window.atob(jwtSplit[1]));
    if (!body.exp) return false;
    const date = new Date();
    return body.exp > (date.getTime() / 1000 + beforeExpireSeconds);
  }

  async refreshToken(): Promise<any> {
    const user = await this.getUser();
    if (!user) throw new Error("login_required");
    // @ts-ignore
    const resp = await this.userManager._useRefreshToken({ refresh_token: user.refresh_token });
    if (resp) return resp;
    throw new Error("refresh_token_error");
  }

  async getAccessToken(): Promise<string> {
    try {
      let user = await this.getUser();
      if (this.validateToken(user['access_token'], 30)) {
        return user['access_token'];
      } else if (this.validateToken(user['refresh_token'], 10)) {
        user = await this.refreshToken();
        return user['access_token'];
      } else {
        throw new Error("login_required");
      }
    } catch (error: any) {
      if (error.message === "refresh_token_error")
        throw new Error("login_required");
      else
        throw error;
    }
  }

  async getCurrentUserInfo(): Promise<any> {
    return this.ajaxHelper(this.userInfoUrl);
  }

  async getBindingCompaniesInfo(): Promise<any> {
    return this.ajaxHelper(this.userInfoUrl + '?IncludeB1UserBinding=true');
  }

  async ajaxHelper(url: string, settings?: any): Promise<any> {
    try {
      const accessToken = await this.getAccessToken();
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      });
      
      return this.http.get(url, { headers, ...settings }).toPromise();
    } catch (error: any) {
      if (error.message === "login_required") {
        await this.startSignoutRedirect();
        throw error;
      }
      throw error;
    }
  }

  formatOidcErr(oidcError: any, ...args: any[]): Error {
    if (oidcError.message) {
      if (oidcError.message.match("iat is in the future") || oidcError.message.match("exp is in the past")) {
        return new Error(`You cannot log in due to a time synchronization issue. Please contact your system administrator.`);
      }
      if (oidcError.message.match("discoveryUri_error") && args) {
        return new Error(`Cannot connect to the authentication service discovery URL ${args[0]}. For more information, see SAP Note 3237004.\nIt is very likely that the authentication server address is not accessible or there is a certificate issue.\nDo you want to check this page in a new window?`);
      }
    }
    return oidcError;
  }
}
1